export default __webpack_public_path__ + "static/media/camera.d2a3ccf5.svg";